import { render, staticRenderFns } from "./ClosureRemarksFormBox.vue?vue&type=template&id=225d8d10"
import script from "./ClosureRemarksFormBox.vue?vue&type=script&lang=js"
export * from "./ClosureRemarksFormBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports